module.exports = __webpack_public_path__ + "static/media/Employee.8719ad35.PNG";